import {
    GET_RM_LIST_PROGRESS, GET_RM_LIST_SUCCESS, GET_RM_LIST_FAILURE,
    ADD_RM_PROGRESS, ADD_RM_SUCCESS, ADD_RM_FAILURE,
    EDIT_DELETE_RM_PROGRESS, EDIT_DELETE_RM_SUCCESS, EDIT_DELETE_RM_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    rm: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const rm_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_RM_LIST_SUCCESS:
            return { ...state, rm: action.rm, loading: false };
        case GET_RM_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_RM_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_RM_PROGRESS:
            return { ...state, loading: true };
        case ADD_RM_SUCCESS:
            return { ...state, rm: [...state.rm, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_RM_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_RM_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_RM_SUCCESS:
            return {
                ...state,
                rm: state.rm.map((rm) =>
                    rm.id === action.payload.id ? action.payload : rm
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_RM_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default rm_reducer;